/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GradientRadialClosestSide(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GradientRadialClosestSide',
      'aria-hidden': true,
      focusable: false,
      width:  17 * scale,
      height: 14 * scale,
      viewBox: '0 0 17 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('circle', {"fill":"#41A2F2","cx":"6.5","cy":"6.5","r":"4.5","opacity":".5"}),createElement('path', {"fill":"#7AB8FF","d":"M6 2v3h1V2"}),createElement('circle', {"fill":"currentColor","cx":"6.5","cy":"6.5","r":"1.5"}),createElement('path', {"fill":"currentColor","d":"M1 1h15v1H1z"}),createElement('path', {"opacity":".4","fill":"currentColor","d":"M2 12V2h13v10zM16 1H1v12h15z"}))
}
